import { useState, useMemo } from 'react';

export interface TableState<T> {
  pageIndex: number;
  pageSize: number;
  setPageIndex: (index: number) => void;
  setPageSize: (size: number) => void;
  getPaginatedData: () => T[];
}

export function useTableState<T>(data: T[], initialPageSize = 10): TableState<T> {
  const [pageIndex, setPageIndex] = useState(0);
  const [pageSize, setPageSize] = useState(initialPageSize);

  const getPaginatedData = useMemo(() => {
    return () => {
      const start = pageIndex * pageSize;
      const end = start + pageSize;
      return data.slice(start, end);
    }
  }, [data, pageIndex, pageSize]);

  return {
    pageIndex,
    pageSize,
    setPageIndex,
    setPageSize,
    getPaginatedData,
  };
}
